function User(data){
    var self = this;
    if(data){
        Object.keys(data).forEach(function(index){
            self[index] = data[index];
        });
    }
}
User.prototype = {
    can(perm) {
        if(!this.permissions_flat || this.permissions_flat.length === 0) {
            return false;
        }
        return this.permissions_flat.indexOf(perm) !== -1;
    },
    canAny(perms) {
        let can = false;
        perms.forEach(((perm) => {
            if(this.can(perm)) {
                can = true;
            }
        }).bind(this));
        return can;
    },
    canAll(perms) {
        let can = true;
        perms.forEach(((perm) => {
            if(!this.can(perm)) {
                can = false;
            }
        }).bind(this));
        return can;
    }
};
export default User;